import { AxiosPromise } from "axios";
import { apiWrapper } from "../../axiosInstance";
import { GetCapabilitiesServiceResponse } from "./getCapabilities.service";

export const getCapabilitiesEndpoint = (): AxiosPromise<GetCapabilitiesServiceResponse> =>
    apiWrapper.instance!.get(
        `wfs?service=wfs&version=2.0.0&request=GetCapabilities&outputFormat=application/json&srsName=EPSG:4326`
    );
